import { getLocale } from "@/utils/locale";
import { getThemePreference } from "@/utils/theme";
import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";
import * as directives from "vuetify/directives";
import { de, en, es, fr, nl } from "vuetify/locale";
import "vuetify/styles";
import colors from "vuetify/util/colors";

const brandColors = {
  primary: "#00A9BA",
  success: "#00A9BA",
  warn: "#D75A00",
  error: colors.red.base,
  grey: colors.grey.base,
};

/** Keep in sync with `styles/tailwind.css` and `styles/settings.scss`. */
const displayThresholds = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
  xxl: 2560,
};

export default createVuetify({
  directives,
  locale: {
    locale: getLocale(),
    messages: { fr, en, de, nl, es },
  },
  display: {
    mobileBreakpoint: "md",
    thresholds: displayThresholds,
  },
  theme: {
    defaultTheme: getThemePreference(),
    // Keep Vuetify theme classes (`bg-primary` + on-primary contrast).
    // Tailwind is for layout/type scale; it does not own theme color utilities.
    themes: {
      light: {
        colors: brandColors,
      },
      dark: {
        colors: {
          ...brandColors,
          // Soften Vuetify's default purple-tinted surface-bright.
          "surface-bright": "#383838",
        },
      },
    },
  },
  defaults: {
    VForm: {
      validateOn: "invalid-input lazy",
    },
    VBtn: {
      variant: "flat",
    },
    VAutocomplete: {
      variant: "outlined",
      density: "compact",
      color: "primary",
    },
    VSelect: {
      variant: "outlined",
      density: "compact",
    },
    VTextField: {
      variant: "outlined",
      density: "compact",
    },
    VAlert: {
      variant: "tonal",
      density: "compact",
      border: true,
      color: "primary",
    },
    VTooltip: {
      location: "bottom",
      // Avoid mounting overlays for every tooltip up front (large lists).
      eager: false,
    },
    // The loading bar reads this color. Unset, it inherits on-surface.
    // Nested so selection, sort, and pagination keep their own colors.
    VDataTable: {
      VProgressLinear: { color: "primary" },
    },
    VDataTableServer: {
      VProgressLinear: { color: "primary" },
    },
    VDataTableVirtual: {
      VProgressLinear: { color: "primary" },
    },
  },
});
